<template>
  <L1 class="Home">
    <template slot="slot_title">
      <RT :style="{marginLeft: '26px'}" :height="'50px'" :width="'200px'" :options="['營運服務', '會員專區', '出勤/統計', '設定']" :defaultValue="page" @input="$router.replace({ name: $route.name, query: { page: $event } })"/>
    <div id="version">version: {{VUE_APP_VERSION}}</div>
    <EditBtn :style="{marginLeft: 'auto', minWidth: '32px'}" @click="setEdit" v-if="!edit"></EditBtn><SaveBtn :style="{marginLeft: 'auto'}" text="儲存" @click="saveDashboard" v-else></SaveBtn>
    </template>
    <div :style="{flexDirection: 'column'}" class="groups">
    <div :style="{display: 'flex'}" label="TEST_1" v-if="linksGroup1.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup1" :key="`link-1-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_2" v-if="linksGroup2.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup2" :key="`link-2-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_2" v-if="linksGroup3.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup3" :key="`link-3-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_2" v-if="linksGroup4.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup4" :key="`link-4-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_2" class="linksGroup5" v-if="linksGroup5.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup5" :key="`link-5-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_2" v-if="linksGroup6.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup6" :key="`link-5-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_7" v-if="linksGroup7.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup7" :key="`link-5-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image"  :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    <div :style="{display: 'flex'}" label="TEST_2" v-if="linksGroup8.length>0">
      <div>
        <div class="btnBox" v-for="(link, index) in linksGroup8" :key="`link-4-${index}`">
          <input type="checkbox" v-model="dashboardSelected" :value="link.name" v-show="edit">
          <btnCube :disabled="edit||!!link.meta.disabled" @push="$router.push(link.query ? {name: link.name, query: link.query} : {name: link.name})" :ImgSize="link.meta.size"
          :name="link.meta.title" :name_eng="link.meta.label_en" :color="link.meta.color" :image="link.meta.image" :note="link.meta.note" :position="link.meta.position"/>
        </div>
      </div>
    </div>
    </div>
  </L1>
</template>

<script>
import EditBtn from '../components/btn/edit.vue'
import SaveBtn from '../components/btn/saveTemp.vue'
import L1 from '../components/layout/L3.vue'
import btnCube from '../components/homeButtonCube.vue'
import { postapi } from '../store/fetch'
const VUE_APP_VERSION = process.env.VUE_APP_VERSION

export default {
  name: 'Home',
  components: {
    btnCube,
    L1,
    SaveBtn,
    EditBtn
  },
  methods: {
    setEdit () {
      this.dashboardSelected = this.dashboard ? this.dashboard : []
      this.edit = true
    },
    async saveDashboard () {
      const r = await postapi('users/me', { dashboard: this.dashboardSelected })
      if (r && r.success) {
        this.$store.commit('setUser', r.data)
        this.edit = false
      }
    },
    filters (router, role, department, g) {
      const production = !(/dev/i.test(location.origin) || /localhost/i.test(location.origin))
      if (production) {
        if (role === 'manager') {
          return router.filter(e => e.meta.production && e.meta.group === g && e.meta.role.includes(role) && (!e.meta.manager || e.meta.manager.includes(department)))
        } else if (role === 'employee') {
          return router.filter(e => e.meta.production && e.meta.group === g && e.meta.role.includes(role) && (!e.meta.employee || e.meta.employee.includes(department)))
        } else {
          return router.filter(e => e.meta.production && e.meta.group === g && e.meta.role.includes(role))
        }
      } else {
        if (role === 'manager') {
          return router.filter(e => e.meta.group === g && e.meta.role.includes(role) && (!e.meta.manager || e.meta.manager.includes(department)))
        } else if (role === 'employee') {
          return router.filter(e => e.meta.group === g && e.meta.role.includes(role) && (!e.meta.employee || e.meta.employee.includes(department)))
        } else {
          return router.filter(e => e.meta.group === g && e.meta.role.includes(role))
        }
      }
    }
  },
  computed: {
    page () {
      return this.$route.query.page || '營運服務'
    },
    role () {
      return this.$store.getters.myRole
    },
    department () {
      return this.$store.getters.myDepartment
    },
    router () {
      return this.$router.options.routes.find(e => e.name === 'LoggedIn').children.filter(e => e.meta.appCube).filter(e => e.meta.category === this.page)
    },
    dashboard () {
      return this.$store.state.user.dashboard.filter(e => e)
    },
    linksGroup1 () {
      return this.filters(this.router, this.role, this.department, 1)
    },
    linksGroup2 () {
      return this.filters(this.router, this.role, this.department, 2)
    },
    linksGroup3 () {
      return this.filters(this.router, this.role, this.department, 3)
    },
    linksGroup4 () {
      return this.filters(this.router, this.role, this.department, 4)
    },
    linksGroup5 () {
      return this.filters(this.router, this.role, this.department, 5)
    },
    linksGroup6 () {
      return this.filters(this.router, this.role, this.department, 6)
    },
    linksGroup7 () {
      return this.filters(this.router, this.role, this.department, 7)
    },
    linksGroup8 () {
      return this.filters(this.router, this.role, this.department, 8)
    }
  },
  data () {
    return {
      dashboardSelected: [],
      infoShow: false,
      edit: false,
      VUE_APP_VERSION
    }
  }

}
</script>
<style lang="scss">
.Home>.L3_title {
  position: relative;
}
</style>
<style lang="scss" scoped>
#version {
  position: absolute;
  bottom: 2px;
  right: 2px;
  font-size: 12px;
  width: fit-content;
  color: var(--color-border);
}
.groups {
  padding: 32px;
  &>div{
    display: flex;
    width: 100%;
    &>div{
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      gap: 20px;
    }
  }
}
.btnBox {
  position: relative;
}
input[type=checkbox] {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
  border: 2px solid #FFFFFF;
  z-index: 40;
  border-radius: 15px;
  appearance: none;
  background-color: #FFFFFF80;
  &:checked {
    background-image: url(./checkmark.svg);
    background-size: 17px;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.titleHome {
  height: 53px;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 87px;
  /* identical to box height */
  letter-spacing: 0.15em;
  padding-inline: 18px 44px;
  text-indent: 13px;
  color: var(--color-pri);
  height: 89px;
  text-align: start;
  &>div {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  button {
    width: 43px;
    height: 42px;
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
  }
  hr {
    margin: 0;
    padding: 0;
    width: 100%;
    border-bottom:  1px solid var(--color-border);
  }
}
.Home {
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  &>div:not(.titleHome) {
    padding-block: 20px;
    padding-inline: 30px;
    width: 100%;
    height: fit-content;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    // background-color: cornflowerblue;
    &>div {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      // background-color: chartreuse;
      gap: 25px 24px;
      align-items: flex-start;
      justify-content: flex-start;
    }
    &::before {
      content: attr(label);
      display: inline-block;
      display: none;
      height: 35px;
      text-align: start;
    }
  }
  &::-webkit-scrollbar {
    width: 7px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    box-shadow: inset 0 0 6px #0000004d;
    background-color: var(--color-pri);
  }
  &::-webkit-scrollbar-track {
    border: 1px solid #0000004d;
    background-color: #F5F5F5;
  }
}
</style>
